import * as React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@app/store';
import { setPopular } from '@app/store/catalogue/thunks';
import './style.scss';
import { CatalogMobileTitleNavigationProps } from './CatalogMobileTitleNavigationProps';
import { MetricParam, useSpatz } from '@app/hooks/useSpatz';

const CatalogMobileTitleNavigation: React.FC<
  CatalogMobileTitleNavigationProps
> = ({ isPopular, setPopular }) => {
  const { sendSpatzStats } = useSpatz({
    Services: { catalog: { Главная: { 'клик на группу разделов': {} } } },
  });

  const onClickHandler = (bool: boolean) => {
    const data: MetricParam = {
      click: !isPopular ? 'Избранное' : 'Все услуги',
    };
    sendSpatzStats(data);
    setPopular(bool);
  };
  return (
    <div
      className="mos-catalog_category-title mos-catalog_category-title_navigation"
      role="navigation"
    >
      <button
        onClick={() => onClickHandler(true)}
        aria-label="Популярные услуги"
        role="tab"
        aria-selected={isPopular ? 'true' : 'false'}
        className={isPopular ? 'active' : undefined}
      >
        Популярное
      </button>
      <button
        onClick={() => onClickHandler(false)}
        role="tab"
        aria-selected={!isPopular ? 'true' : 'false'}
        className={!isPopular ? 'active' : undefined}
      >
        Все услуги
      </button>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  isPopular: state.catalogue.isPopular,
});

const dispatchProps = {
  setPopular,
};

const ConnectedCatalogMobileTitleNavigation = connect(
  mapStateToProps,
  dispatchProps
)(CatalogMobileTitleNavigation);

export default ConnectedCatalogMobileTitleNavigation;
